export class FormularioGatewayModel {
  schema: string;
  model: string;
  problemas?: string | null;
}
